import { Iso8601DateString } from '@connect-x-app/shared-types';

import { Task } from '../task';
import { Channel } from './channel';
import { FlightRoomUserStatus } from './flightRoomUser';

export type LegLocation = {
  airport: Airport;
  gate?: string;
  parking?: string;
  runway?: string;
  terminal?: string;
  timeZone?: string;
};

export type FlightRoomSummary = {
  accessRequestCount: number;
  account: string;
  aircraft: string | null;
  archived?: boolean | null;
  atcCallSign?: string | null;
  closed: boolean;
  createdAt: string;
  departure: LegLocation;
  desk?: string | null;
  destination: LegLocation;
  externalId: string;
  flightNumber: string;
  hasUnreadMentions: boolean;
  id: string;
  locked: boolean;
  muted: boolean;
  mutedUntilDurationBeforeDeparture: string | null;
  nextLeg?: string | null;
  previousLeg?: string | null;
  schedule: {
    ata?: Iso8601DateString | null;
    atd?: Iso8601DateString | null;
    eta?: Iso8601DateString | null;
    etd?: Iso8601DateString | null;
    processedArrivalTime: Iso8601DateString;
    processedDepartureTime: Iso8601DateString;
    sta: Iso8601DateString;
    std: Iso8601DateString;
  };
  // Internal mapping
  status?: FlightStatus;
  tasks?: Task[];
  unreadMessagesCount: number;
  updatedAt: string;
  userStatus?: FlightRoomUserStatus;
};

export type FlightRoomSearchSummary = Omit<
  FlightRoomSummary,
  'accessRequestCount' | 'hasUnreadMentions' | 'status' | 'unreadMessagesCount'
>;

export type FlightRoomDetail = FlightRoomSummary & {
  customChannels: Channel[];
  mainChannel: Channel;
};

export type Airport =
  | {
      iata: string;
      icao: string;
    }
  | {
      iata: string;
      icao: null | undefined;
    }
  | {
      iata: null | undefined;
      icao: string;
    };

export enum FlightStatus {
  ACTIVE = 'ACTIVE',
  LANDED = 'LANDED',
  TASKS = 'TASKS',
}

export enum FlightroomDeepLinkAction {
  JOIN = 'join',
}
